import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(0.75, 1.25),
  },
  text: { color: theme.palette.text.secondary },
  button: {
    whiteSpace: 'nowrap',
  },
}));

export default function MillsSalesCta() {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography variant="caption" className={classes.text}>
        Need additional Mills rack pricing and market coverage?
      </Typography>
      <Button
        component={RouterLink}
        to="/contactus"
        size="small"
        variant="outlined"
        color="primary"
        className={classes.button}
      >
        Contact Sales
      </Button>
    </Box>
  );
}
